import React, { useState } from "react";
import Modal from "../common/Modal/Modal";
import { JobsDataType } from "../../types/api-response";
import { useDeleteJobMutation } from "../../redux/apis/manageJobPostingHooks";
import { toast } from "react-toastify";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  modalData?: JobsDataType[] | null;
  setSelectedRowData?: Function;
}

const DeleteJobsModal = ({ isOpen,
  setIsOpen,
  modalData,
  setSelectedRowData = () => {},
}: Props) => {
  const [jobIds, setJobIds] = useState<any>([]);
  let jobTitle = '';
  const [deleteJob, { isError, isSuccess, isLoading, data, error }] = useDeleteJobMutation();

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDeleteJob = async() => {
    const idsToDelete = modalData ? modalData.map((row) => row.jobId) : jobIds;
    if(idsToDelete.length === 1){
      jobTitle = (modalData ? modalData.map((row) => row.title)[0] : "");
    }

    try {
      const result = await deleteJob(idsToDelete).unwrap();
      if (isSuccess || result.length >= 1) {
        toast.success(`${jobTitle} Job posting${jobTitle ? "" : "(s)"} successfully deleted`, {
          autoClose: 5000,
          position: "bottom-left",
          toastId: "success-toast-custom",
        });
        if(setSelectedRowData) {
          setSelectedRowData([]);
        }
        handleClose();
      } 
    } catch (error) {
      toast.error("Error deleting job!", {
        autoClose: 5000,
        position: "bottom-left",
        toastId: "error-toast-custom",
      });
      handleClose();
    }
  };


  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-delete-job"
        isOpen={isOpen}
        onClose={() => {
          if (!isLoading) {
            setIsOpen(false);
          }
        }}
        width="475px"
      >
        <div className="mjp-modal-body delete-jobs-body">
        <strong>Are you sure you want to delete this job post?</strong>
        </div>

        <div  className="delete-jobs-footer">
        <div>
          <button
            className="foundit-button medium full-width delete-cancel-button"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={handleDeleteJob}
            disabled={isLoading}
          >
            {!isLoading ? "Confirm" : "Deleting..."}
          </button>
        </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default DeleteJobsModal;
